(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spacevideo-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {

  var swiper = new Swiper('.spacevideo-slider .spacevideo-swiper', {

    slidesPerView: 2,
    spaceBetween: 20,
    speed: 800,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.spacevideo-slider .swiper-pagination',
      clickable: true,
    },

    breakpoints: {
      320: { slidesPerView: 1 },
      768: { slidesPerView: 2 },
      1024: { slidesPerView: 2 }
    },

    on: {
      init: function () {
        const sliderEl = document.querySelector('.spacevideo-slider .spacevideo-swiper');
        if (!sliderEl) return;

        // Mouse enter stops autoplay (kept as before)
        sliderEl.addEventListener('mouseenter', () => swiper.autoplay.stop());
        sliderEl.addEventListener('mouseleave', () => {
          /* nothing here (kept as your request) */
        });

        // Collect iframes and ensure unique ids
        let iframes = Array.from(sliderEl.querySelectorAll('iframe'));
        iframes.forEach((iframe, idx) => {
          if (!iframe.id) {
            iframe.id = 'spacevideo-iframe-' + idx + '-' + Date.now();
          }
        });

        // Send the "listening" handshake to each iframe so we receive onStateChange messages
        iframes.forEach((iframe) => {
          try {
            iframe.contentWindow.postMessage(JSON.stringify({
              event: "listening",
              id: iframe.id,
              channel: "widget"
            }), "*");
          } catch (e) {
            // ignore cross-origin timing issues
          }
        });

        // Track currently playing iframe (so we only stop the previous one)
        let currentPlayingIframe = null;
        let currentPlayingId = null;

        // Helper to send stop to a specific iframe
        function stopIframe(iframe) {
          if (!iframe) return;
          try {
            iframe.contentWindow.postMessage(JSON.stringify({
              event: "command",
              func: "stopVideo",
              args: []
            }), "*");
          } catch (e) {
            // ignore
          }
        }

        // Listen for messages from YouTube players
        window.addEventListener("message", function (event) {
          let data;
          try {
            data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
          } catch (e) {
            return; // not JSON — ignore
          }

          if (!data || data.event !== "onStateChange") return;

          // Find the iframe that sent this message:
          let sourceIframe = null;
          if (data.id) {
            sourceIframe = iframes.find(f => f.id === data.id) || null;
          }
          if (!sourceIframe) {
            // fallback: match by event.source (contentWindow)
            sourceIframe = iframes.find(f => f.contentWindow === event.source) || null;
          }

          // PLAYING (1)
          if (data.info === 1) {
            // If another video is currently playing, stop that previous one.
            if (currentPlayingIframe && currentPlayingIframe !== sourceIframe) {
              stopIframe(currentPlayingIframe);
            }

            // Set this as the current playing iframe
            currentPlayingIframe = sourceIframe || null;
            currentPlayingId = sourceIframe ? sourceIframe.id : null;

            // Stop Swiper autoplay when a video plays
            try { swiper.autoplay.stop(); } catch (e) {}

            return;
          }

          // PAUSED (2) or ENDED (0)
          if (data.info === 2 || data.info === 0) {
            // Only clear currentPlaying if the event is coming from the currently playing iframe
            if (sourceIframe && sourceIframe === currentPlayingIframe) {
              currentPlayingIframe = null;
              currentPlayingId = null;
              try { swiper.autoplay.start(); } catch (e) {}
            }
            return;
          }

        }); // end window.message listener

      } // end init
    } // end on
  }); // end Swiper init

});

  } catch(e) { console.error(e); }
})();
})();
